import gql from 'graphql-tag';

const MOVE_ITEM_MUTATION = gql`
  mutation moveCategoryItem($_id: ID!, $offset: Int, $order: Int) {
    moveCategoryItem(_id: $_id, offset: $offset, order: $order) {
      _id
      order
    }
  }
`;

export default MOVE_ITEM_MUTATION;
